import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Media } from '../classes/index';

@Injectable()
export class MediaService {

	constructor(private firestore: Firestore) {
	}

	listMedias(collectionPath) {
		return collectionData(collection(this.firestore, collectionPath), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				delete data.collectionPath;
				let object = new Media(collectionPath);
				object.fromJSON(data);
				return object;
			});
		}))
		.pipe(map(roles => roles.sort((a, b) => {
			if (a.orderNum > b.orderNum) return 1;
			else if (a.orderNum < b.orderNum) return -1;
			else return 0;
		})));
	}

	createMediaRef(collectionPath){
		return doc(collection(this.firestore, collectionPath));
	}

	setMedia(media) {
		let data = { ...media };
		console.log('Set media:'+JSON.stringify(data));
		delete data.collectionPath;
		return setDoc(doc(this.firestore, media.collectionPath, media.id), data);
		/*let ref = this.afs.collection(media.collectionPath).doc().ref;
		media.id = ref.id;
		return ref.set(data);*/
	}

	updateMedia(media, data){
		data.collectionPath = deleteField();
		return updateDoc(doc(this.firestore, media.collectionPath, media.id), data);
	}

	deleteMedia(media) {
		return deleteDoc(doc(this.firestore, media.collectionPath, media.id));
	}
}

